import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import {
  AddDeviceRequest,
  Device,
  DeviceDetails,
} from './types';

export const getDevices = async () => {
  const response = await apiRequest<Response<Device[]>, void>(
    endpoints.device.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const getDeviceDetails = async (deviceId: number) => {
  const response = await apiRequest<Response<DeviceDetails>, void>(
    endpoints.device.getDetails(deviceId),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const addDevice = async (data: AddDeviceRequest) => {
  const response = await apiRequest<Response<Device>, AddDeviceRequest>(
    endpoints.device.add,
    RequestMethodEnum.POST,
    { data }
  );
  return response?.data;
};

export const deleteDevice = async (id: number) => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.device.delete(id),
    RequestMethodEnum.DELETE,
    { showErrorMessage: true, showSuccessMessage: true }
  );
  return response?.data;
};
